import { Box } from 'shared/mui/Box';
import { ConditionGroup } from 'types/embedded/gatewayRule';

import {
  GatewayRuleConditionFieldList,
  GatewayRuleConditionFieldListItem,
  GatewayRuleConditionFieldListItemDot,
} from './GatewayRuleConditionFieldList';
import { GatewayRuleFieldExpression } from './GatewayRuleFieldExpression';
import { GatewayRuleGroupIsAnd } from './GatewayRuleGroupIsAnd';

type Props = {
  shade?: number;
  isOnlyOneExpression?: boolean;
  className?: string;
  group: ConditionGroup;
};

export function GatewayRuleFieldGroup({
  shade = 0,
  group,
  className,
  isOnlyOneExpression,
}: Props): JSX.Element {
  const SHADE_STEP = 0.04;

  return (
    <GatewayRuleConditionFieldList
      className={className}
      style={{
        marginBottom: '12px',
      }}
    >
      {!isOnlyOneExpression && (
        <GatewayRuleConditionFieldListItem>
          <Box>
            <GatewayRuleGroupIsAnd isAnd={group.isAnd} />
          </Box>
        </GatewayRuleConditionFieldListItem>
      )}
      <GatewayRuleConditionFieldList
        style={{
          marginLeft: isOnlyOneExpression ? '0' : '32px',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <GatewayRuleConditionFieldListItemDot />
        {group?.expressions?.length > 0 &&
          group?.expressions?.map((expression) => (
            <GatewayRuleConditionFieldListItem key={expression.id}>
              {!isOnlyOneExpression && <GatewayRuleConditionFieldListItemDot />}
              <GatewayRuleFieldExpression expression={expression} key={expression.id} />
            </GatewayRuleConditionFieldListItem>
          ))}
      </GatewayRuleConditionFieldList>

      {group?.children?.length > 0 &&
        group?.children?.map((group, index) => (
          <GatewayRuleConditionFieldListItem
            key={index}
            style={{
              marginLeft: '32px',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <GatewayRuleFieldGroup
              className="nested"
              group={group}
              isOnlyOneExpression={false}
              key={index}
              shade={shade + SHADE_STEP}
            />
          </GatewayRuleConditionFieldListItem>
        ))}
    </GatewayRuleConditionFieldList>
  );
}
